export const cadsAdminStaffId = '96dcc7ab-3b70-49a9-9cde-413e07a296fd';
